import { saga as sagaAnimation } from './saga.animation';
import { saga as sagaCommands } from './saga.commands';
import { saga as sagaEnvironment } from './saga.environment';
import { saga as sagaQuality } from './saga.quality';
import { saga as sagaRealtime } from './saga.realtime';
import { saga as sagaScene } from './saga.scene';
import { saga as sagaScreenshots } from './saga.screenshots';
import { saga as sagaStudio } from './saga.studio';
import { saga as sagaThree } from './saga.three';
import { saga as sagaTransform } from './saga.transform';

export const sagas = {
  'sloyd.animation': sagaAnimation,
  'sloyd.three': sagaThree,
  'sloyd.studio': sagaStudio,
  'sloyd.screenshots': sagaScreenshots,
  'sloyd.realtime': sagaRealtime,
  'sloyd.transform': sagaTransform,
  'sloyd.quality': sagaQuality,
  'sloyd.environment': sagaEnvironment,
  'sloyd.commands': sagaCommands,
  'sloyd.scene': sagaScene,
};
